import { render, staticRenderFns } from "./my-activeDetail.vue?vue&type=template&id=5090459c&scoped=true&"
import script from "./my-activeDetail.vue?vue&type=script&lang=js&"
export * from "./my-activeDetail.vue?vue&type=script&lang=js&"
import style0 from "./my-activeDetail.vue?vue&type=style&index=0&id=5090459c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5090459c",
  null
  
)

component.options.__file = "my-activeDetail.vue"
export default component.exports